export const TenantsEnum = {
  trip2: 't2',
  av: 'av',
  clm: 'clm',
  clmt: 'clmt'
};



// WEBPACK FOOTER //
// ./src/app/core/enums/tenants.enum.ts